var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvolopeV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#191918",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    clipPath: "url(#" + _uid + "envolope-v2_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.375 10 11.25 2.5 4.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.375h15V15a.624.624 0 0 1-.625.625H3.125A.625.625 0 0 1 2.5 15zM8.637 10l-5.944 5.448M17.307 15.448 11.363 10"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "envolope-v2_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export { SvgEnvolopeV2 as ReactComponent };
export default __webpack_public_path__ + "e373b4a6a1639005ab9454ad9e271f1a.svg";